import {actions} from "react-fields";

class EducatorAPI {

    static update(user, onSuccess, onError) {
        const url = '/api/educator';
        let data = { educator: {...user} };
        delete data.educator.errors;
        fetch(actions.putRequest(url, data ))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            }).then( (response) => {
            onSuccess(response);
        }).catch(error => {
            console.log(error);
            error.json().then(function (value) {
                onError(value);
            });
        });
    }

    static changeEmail(user, onSuccess, onError) {
        const url = '/group/register';
        let data = {educator: { email: user.email, current_password: user.current_password}};

        fetch(actions.putRequest(url, data ))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            }).then( (response) => {
            onSuccess(response);
        }).catch(error => {
            console.log(error);
            error.json().then(function (value) {
                onError(value);
            });
        });
    }

    static changePassword(user, onSuccess, onError) {
        const url = '/group/register';
        let data = {educator: {
                password: user.new_password,
                password_confirmation: user.password_confirmation,
                current_password: user.current_password}};

        fetch(actions.putRequest(url, data ))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            }).then(  (response) => {
            onSuccess(response);
        }).catch(error => {
            console.log(error);
            error.json().then(function (value) {
                onError(value);
            });
        });
    }

    static getTestsStats(period) {
        let url = `/api/educator/tests_stats?period=${period}`;

        return fetch(actions.getData(url))
            .then(actions.status)
            .then(actions.json)
    }

    static offer(user, offer_id, onSuccess, onError) {
        const url = '/api/educator/offer';
        let data = { educator: {...user}, offer_id: offer_id };
        delete data.educator.errors;
        fetch(actions.postRequest(url, data ))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            }).then( (response) => {
            onSuccess(response);
        }).catch(error => {
            console.log(error);
            error.json().then(function (value) {
                onError(value);
            });
        });
    }

    static validateVat(data, onSuccess, onError) {
        const url = '/api/educator/validate_vat';
        if (!data.country_id) {
            return onError('Country is required');
        }
        if (!data.country_id) {
            return onError('VAT Number is required');
        }
        fetch(actions.postRequest(url, data )).then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            }).then( (response) => {
            onSuccess(response);
        }).catch(error => {
            console.log(error);
            error.json().then(function (value) {
                onError(value);
            });
        });
    }

}

export default EducatorAPI;